import React from 'react';
import IconActionButton from 'Components/pos2u/Buttons/IconActionButton';
import { UncontrolledTooltip } from 'reactstrap';
import { RiDeleteBin2Line } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';

interface DeleteIconWithDisabledButtonProps {
  id: string;
  onClick: () => void;
  disabled?: boolean;
  tooltipWhenDisabled?: string;
  height?: string;
  width?: string;
  fontSize?: string;
  className?: string;
  style?: React.CSSProperties;
  btnClass?: string;
}

const DeleteIconWithDisabledButton: React.FC<
  DeleteIconWithDisabledButtonProps
> = ({
  id,
  onClick,
  disabled = false,
  tooltipWhenDisabled = '',
  height = '32px',
  width = '32px',
  fontSize = '20px',
  className = '',
  style = {},
  btnClass = 'btn-outline-danger',
}) => {
  const clickHandler = () => {
    if (disabled) return;
    onClick();
  };
  const { t } = useTranslation();

  return (
    <>
      <div id={id}>
        <IconActionButton
          onClick={clickHandler}
          icon={<RiDeleteBin2Line fontSize={fontSize} />}
          title={t('Delete')}
          height={height}
          width={width}
          className={className}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            ...style,
          }}
          btnClass={btnClass}
        />
      </div>
      {disabled && tooltipWhenDisabled && (
        <UncontrolledTooltip placement="top" target={id}>
          {tooltipWhenDisabled}
        </UncontrolledTooltip>
      )}
    </>
  );
};

export default DeleteIconWithDisabledButton;
